/**
 * The colour themes people can choose in settings.
 *
 * A theme is its values in src/styles/themes/_<id>.scss (light and dark),
 * registered in src/styles/themes/_index.scss; this list is what the pickers
 * offer, in this order. The mode (Light / Dark / System) is a separate
 * choice, so every theme comes in both. Adding a theme: see
 * src/styles/themes/_theme-api.scss.
 */
export interface AppTheme {
  /** The value of body[data-app-theme]; the id the stylesheet registers. */
  id: string;
  /** Strings key of its name, shown in the pickers. */
  nameKey: string;
}

export const APP_THEMES: readonly AppTheme[] = [
  {id: 'classic', nameKey: 'app_theme_classic'},
  {id: 'graphite', nameKey: 'app_theme_graphite'},
  {id: 'paper', nameKey: 'app_theme_paper'},
  {id: 'survey', nameKey: 'app_theme_survey'},
  {id: 'meadow', nameKey: 'app_theme_meadow'},
  {id: 'glacier', nameKey: 'app_theme_glacier'},
  {id: 'dusk', nameKey: 'app_theme_dusk'},
  {id: 'hi-vis', nameKey: 'app_theme_hi_vis'},
  {id: 'lagoon', nameKey: 'app_theme_lagoon'},
  {id: 'contour', nameKey: 'app_theme_contour'},
];

/** The theme of anyone who has not chosen one: the app as it has always looked. */
export const DEFAULT_APP_THEME = 'classic';

/** A known theme id, or the default for anything else (an old or mistyped value). */
export function resolveAppTheme(id: string | null | undefined): string {
  return APP_THEMES.some(t => t.id === id) ? id as string : DEFAULT_APP_THEME;
}
